"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeGetAuthFormStep = void 0;
const reselect_1 = require("reselect");
const getAuthFormStep = (state) => state.authForm.step;
const makeGetAuthFormStep = () => (0, reselect_1.createSelector)(getAuthFormStep, (step) => step);
exports.makeGetAuthFormStep = makeGetAuthFormStep;
